import React from "react";
import Solicitudes from "../../components/2.1 resumen/procesos";

const HomePage = () => {
  return (
    <>
      <Solicitudes />
    </>
  );
};

export default HomePage;
